import { AppBar, Box, Button, ClickAwayListener, Container, CssBaseline, Grid, Grow, Link, makeStyles, MenuItem, MenuList, Paper, Popper, Tab, Tabs, TextField, Toolbar, Typography } from '@material-ui/core';
import { Email, Language, LocationOn, Phone, Send } from '@material-ui/icons';
import React, { useEffect, useRef, useState } from 'react';
import './App.css';
import { Enotites } from './Enotites';
import { IQSProfil as IQSProfil } from './IQSProfil';
import { XronodiagrammaParadoteon } from './XronodiagrammaParadoteon';

const useStyles = makeStyles((theme) => ({
  toolbar: {
    margin: '0 auto'
  },
  toolbarTitle: {
    //flex: 1,
  },
  toolbarSecondary: {
    // justifyContent: 'space-between',
    // overflowX: 'auto',
    color: theme.palette.common.white,
  },
  toolbarLink: {
    // padding: theme.spacing(1),
    // flexShrink: 0,
  },
  mainGrid: {
    marginTop: theme.spacing(3),
  },
  footer: {
    backgroundColor: 'rgb(34,34,34)',
    color: theme.palette.common.white,
    // marginTop: theme.spacing(8),
    padding: theme.spacing(6, 0),
  },
  container: {
  },
  main: {
    backgroundColor: 'rgb(249, 244, 236)',
    minHeight: '56vh'
  },
  appBar: {
    backgroundColor: 'rgb(34,34,34)',
  },
  communication: {
    marginTop: 9,
    marginRight: 8,
    marginBottom: -9,
    color: theme.palette.primary.main,
  },
  banner: {
    maxWidth: '1280px',
    display: 'block',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  homepage: {
    width: '100%',
    display: 'block',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  menulist: {
    background: 'rgba(42, 42, 42, 1)',
    color: 'white',
    width: '304px',
  },
  menulistItem: {
    '&:hover': {
      background: 'rgba(34, 34, 34)',
      color: theme.palette.primary.light,
      fontWeight: 'bolder',
    },
  }
}));

type TabPanelProps = { index: number, value: number }

export const TabPanel: React.FC<TabPanelProps> = props => {
  return (
    props.index === props.value ? <Box p={3} component='div'>
      {props.children}
    </Box> : null
  )
}

export const App = () => {
  const classes = useStyles()

  const [activeTab, setActiveTab] = useState(0)
  const [open, setOpen] = React.useState(false)
  const [activeDescription, setActiveDescription] = useState(0)

  const EMPTY_MESSAGE = { email: '', name: '', message: '', phone: '' }
  const [message, setMessage] = useState(EMPTY_MESSAGE)

  const anchorRef = React.useRef<HTMLAnchorElement | null>(null)

  const handleToggle = (e: any) => {
    setOpen((prevOpen) => !prevOpen);
  }

  const handleClose = (event: any) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  }

  function handleListKeyDown(event: any) {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpen(false);
    }
  }

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = useRef(open);

  useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef?.current?.focus();
    }

    prevOpen.current = open;
  }, [open]);

  return (
    <div className="App">
      <CssBaseline />

      <AppBar position='sticky' className={classes.appBar}>
        <img src="/banner_1d-t.jpg" alt="logo" className={classes.banner} />
        <Toolbar component="nav" variant='dense' className={classes.toolbar}>
          <Tabs value={activeTab} onChange={(_, v) => v !== 1 && setActiveTab(v)} variant="scrollable">
            <Tab color="inherit" className={classes.toolbarLink} wrapped={false} label="ΑΡΧΙΚΗ" />
            <Tab color="inherit" className={classes.toolbarLink} wrapped={false} label="ΠΡΟΦΙΛ" ref={anchorRef as any} onClick={handleToggle} />
            <Tab color="inherit" className={classes.toolbarLink} wrapped={false} label="ΠΡΟΤΥΠΑ ΠΟΙΟΤΗΤΑΣ" />
            <Tab color="inherit" className={classes.toolbarLink} wrapped={false} label="ΓΕΝΙΚΕΣ ΠΛΗΡΟΦΟΡΙΕΣ" />
            <Tab color="inherit" className={classes.toolbarLink} wrapped={false} label="ΑΙΤΗΣΗ ΣΥΜΜΕΤΟΧΗΣ" />
            <Tab color="inherit" className={classes.toolbarLink} wrapped={false} label="Τελευταια Νεα" />
            <Tab color="inherit" className={classes.toolbarLink} wrapped={false} label="ΣΤΟΙΧΕΙΑ ΕΠΙΚΟΙΝΩΝΙΑΣ" />
          </Tabs>
        </Toolbar>
      </AppBar>
      <Container maxWidth="lg" className={classes.container}>

        <main className={classes.main}>
          <Popper style={{ zIndex: 10 }} open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal>
            {({ TransitionProps, placement }) => (
              <Grow {...TransitionProps} style={{ transformOrigin: 'center bottom' }} >
                <Paper>
                  <ClickAwayListener onClickAway={handleClose}>
                    <MenuList autoFocusItem={open} id="menu-list-grow" onKeyDown={handleListKeyDown} className={classes.menulist}>
                      <MenuItem className={classes.menulistItem} onClick={e => { setActiveTab(1); handleClose(e) }}>ΠΡΟΦΙΛ</MenuItem>
                      <MenuItem className={classes.menulistItem} onClick={e => { setActiveTab(1); setActiveDescription(1); handleClose(e) }}>Η Εταιρεία</MenuItem>
                      <MenuItem className={classes.menulistItem} onClick={e => { setActiveTab(1); setActiveDescription(2); handleClose(e) }}>Στόχοι του IQS</MenuItem>
                      <MenuItem className={classes.menulistItem} onClick={e => { setActiveTab(1); setActiveDescription(3); handleClose(e) }}>Ανθρώπινο Δυναμικό</MenuItem>
                    </MenuList>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>


          <TabPanel value={activeTab} index={0}>
            <Grid container spacing={2}
              alignItems="center"
              justify="center">
              <Grid item xs={12}>
                <p>
                  <Typography align='justify'>
                    <img src="/banner_2d_t.jpg" alt="logo" className={classes.homepage} />
                  </Typography>
                </p>
              </Grid>
            </Grid>
          </TabPanel>


          <TabPanel value={activeTab} index={1}>
            <IQSProfil activeDescription={activeDescription} />
          </TabPanel>


          <TabPanel value={activeTab} index={2}>
            <Typography variant='h5'>Πρότυπα Ποιότητας </Typography>
            <p>
              <Typography align='justify'>
                Οι περιβαλλοντικές επιπτώσεις οι οποίες προκύπτουν από τις ανθρώπινες δραστηριότητες στη βιομηχανία, στη γεωργία και την κτηνοτροφία, παράλληλα με τα διατροφικά σκάνδαλα, ευαισθητοποιούν όλο και περισσότερο την παγκόσμια κοινότητα σχετικά με το ζήτημα της παραγωγής. Τα συστήματα ποιότητας αναπτύσσονται σε όλο τον κόσμο μετά από την απαίτηση των καταναλωτών για ασφαλή προϊόντα και τρόφιμα που θα παράγονται με φιλικούς για το περιβάλλον τρόπους. Πιστοποίηση καλείται η απονομή εγγράφων και η καταχώρηση σε καταλόγους που αποδεικνύει τη συμμόρφωση προϊόντων ή/και συστημάτων ποιότητας με τις απαιτήσεις συγκεκριμένων τυποποιητικών εγγράφων.
              </Typography>
            </p>
            <p>
              <Typography align='justify'>
                Το IQS μεταξύ άλλων παρέχει υπηρεσίες εκπαίδευσης και κατάρτισης ως προς τα πρότυπα:
                <ul>
                  <li>
                    Βιολογικής Γεωργίας (Ευρωπαϊκή Νομοθεσία, USDA/ NOP, ΚΡΑV, ΒΙΟSUISSE, ΝΑΤURLAND, Βιοδυναμικής Γεωργίας DEMETER),
                  </ li>
                  <li>
                    GLOBALGAP ΙFA,CROPS BASE (FV & CC), AQUACULTURE MODULE (Finfish, Crustaceans, Molluscs), Chain of Custody (CoC), GRASP,
                  </ li>
                  <li>
                    Πιστοποίηση Προϊόντων Ολοκληρωμένης Διαχείρισης AGRO 2,
                  </ li>
                  <li>
                    Συστημάτων Διαχείρισης της Ασφάλειας των Τροφίμων σύμφωνα με το πρότυπο ΕΛΟΤ ΕΝ ISO 22000,
                  </ li>
                  <li>
                    Συστημάτων Διαχείρισης της Ποιότητας για το πρότυπο ΕΛΟΤ ΕΝ ISO 9001,
                  </ li>
                  <li>
                    Κατάταξης Ξενοδοχείων και Ενοικιαζόμενων Επιπλωμένων Δωματίων-Διαμερισμάτων (ΕΕΔΔ) σε κατηγορίες αστέρων και κλειδιών αντίστοιχα,
                  </ li>
                  <li>
                    NATRUE (για την Πιστοποίηση Βιολογικών και Φυσικών Καλλυντικών),
                  </ li>
                  <li>
                    Σήμα «ΚΡΗΤΗ» (για την Πιστοποίηση Κρητικών Προϊόντων),
                  </ li>
                  <li>
                    ΕΛΛΗΝΙΚΟ ΠΡΩΪΝΟ
                  </ li>
                </ul>
              </Typography>
            </p>
          </TabPanel>



          <TabPanel value={activeTab} index={3}>
            <Typography variant='h5'>Γενικές Πληροφορίες</Typography>
            <Typography align='justify'>
              <ul>
                <li>
                  Όλα τα προγράμματα εκπαίδευσης και κατάρτισης πραγματοποιούνται δια ζώσης σε κατάλληλα διαμορφωμένους χώρους, ή εξ αποστάσεως με τη χρήση αναγνωρισμένης ηλεκτρονικής πλατφόρμας
                </li>
                <li>
                  Μετά την  παρακολούθηση των προγραμμάτων εκδίδεται βεβαίωση στα ελληνικά και στα αγγλικά
                </li>
                <li>
                  Σε όλα τα προγράμματα παρέχεται υλικό εκπαίδευσης σε ηλεκτρονική μορφή
                </li>
                <li>
                  Εφόσον πρόκειται για εταιρικούς πελάτες το κόστος των  προγραμμάτων εκπαίδευσης και κατάρτισης μπορεί να επιδοτηθεί από το πρόγραμμα ΛΑΕΚ 0,24% του ΟΑΕΔ
                </li>
                <li>
                  Υπάρχει πολιτική εκπτώσεων για ομαδικές αιτήσεις, φοιτητές και άνεργους
                </li>
              </ul>
            </Typography>
          </TabPanel>

          <TabPanel value={activeTab} index={4}>
            <Typography variant='h5'>Αίτηση Συμμετοχής</Typography>
            <p>
              <Typography align='center'>
                Για την εκδήλωση ενδιαφέροντος για κάποιο από τα προγράμματα εκπαίδευσης και κατάρτισης παρακαλούμε συμπληρώστε το έντυπο
                <Link color="primary" href="/aitisi2022.docx">
                  {' εδώ '}
                </Link>
                και  αποστολή στο
                <p>
                  <Typography align='center'>
                    <Email className={classes.communication} />
                    <Link color="primary" href="mailto:infoiqscert@gmail.com" >
                      infoiqscert@gmail.com
                    </Link>
                  </Typography>
                </p>
              </Typography>
            </p>
          </TabPanel>

          <TabPanel value={activeTab} index={5}>
            <Typography variant='h5'>Τελευταία Νέα</Typography>

          </TabPanel>


          <TabPanel value={activeTab} index={6}>
            <Typography variant='h5'>Στοιχεία Επικοινωνίας</Typography>
            <Typography align='center'>
              <p>
                <b>
                  IQS<br />
                  ΔΙΕΘΝΕΙΣ ΥΠΗΡΕΣΙΕΣ ΠΙΣΤΟΠΟΙΗΣΗΣ ΠΟΙΟΤΗΤΑΣ Ε.Π.Ε.</b>
              </p>
              <LocationOn className={classes.communication} />Ελευθερίου Βενιζέλου 8<br />

              55 133 ΘΕΣΣΑΛΟΝΙΚΗ<br />

              ΚΑΛΑΜΑΡΙΑ<br />
              <Phone className={classes.communication} /> Τ.+30 2310 029123<br />F.: +30 2310 029124<br />
              <Email className={classes.communication} /> <Link href='mailto:infoiqscert@gmail.com'>infoiqscert@gmail.com</Link> <br />
              <b>LinkedIn</b>: iqs-international-quality-services-ltd
            </Typography>
          </TabPanel>
        </main>
      </Container>

      <footer className={classes.footer}>
        <Container maxWidth="lg">
          <Typography variant="h6" align="center" gutterBottom>
            IQS
          </Typography>
          <Typography variant="body2" color="inherit" align="center">
            {/* TODO: change to iqs site*/}
            <Link color="inherit" href="https://iqs-cert.eu">
              iqs
              {' © '}
            </Link>{' '}
            {new Date().getFullYear()}
            {'. Developed by techyotic.'}
          </Typography>
        </Container>
      </footer>

    </div>
  );
}

export default App;
